<template>
    <v-app :class="scssLocale">
        <loading-component v-show="this.$store.state.loading" />
        <router-view/>
        <error-modal v-model="this.$store.state.errorModalShow" />
        <success-modal v-model="this.$store.state.successModalShow" />
        <notifications position="bottom right" width="350px" classes="notification"/>
    </v-app>
</template>

<script>

import LoadingComponent from './components/LoadingPage'
import ErrorModal from './components/modal/ErrorModal'
import SuccessModal from './components/modal/SuccessModal'

export default {
    name: 'App',

    components: {
        LoadingComponent,
        SuccessModal,
        ErrorModal
    },

    data: () => ({
        //
    }),

    computed: {
        scssLocale () {
            // switch to which scss by current language selected (global.scss)
            return this.$vuetify.lang.current + '-locale'
        }
    }
}
</script>
<style lang="scss">
@import "@/assets/scss/fonts.scss";
@import "@/assets/scss/global.scss";

html {
    overflow-y: hidden !important;
    user-select: none !important;
}
@media only screen and (min-width: 1264px) {
    .container {
        max-width: 100vw;
    }
}
</style>
